import authService from './authService';
import apiClient from './apiClient';

class QuizService {
  // Submit quiz results to backend
  async submitQuizResults(quizData) {
    try {
      const response = await apiClient.post('/quiz/submit', quizData, { headers: { Authorization: `Bearer ${authService.getToken()}` } });
      return response.data;
    } catch {
      throw new Error('Failed to submit quiz results');
    }
  }

  // Get user's quiz history
  async getUserQuizResults(userEmail, limit = 10) {
    try {
      const response = await apiClient.get(`/quiz/results/${encodeURIComponent(userEmail)}?limit=${limit}`, { headers: { Authorization: `Bearer ${authService.getToken()}` } });
      return response.data;
    } catch (error) {
      const status = error.response?.status;
      if (status === 403) throw new Error('Forbidden');
      if (status === 401) throw new Error('Unauthorized');
      throw new Error(error.response?.data?.detail || 'Failed to fetch quiz history');
    }
  }

  // Get detailed quiz result by ID
  async getQuizResultDetail(resultId) {
    try {
      const response = await apiClient.get(`/quiz/result/${resultId}`, { headers: { Authorization: `Bearer ${authService.getToken()}` } });
      return response.data;
    } catch (error) {
      const status = error.response?.status;
      if (status === 403) throw new Error('Forbidden');
      if (status === 401) throw new Error('Unauthorized');
      throw new Error(error.response?.data?.detail || 'Failed to fetch quiz result detail');
    }
  }

  // Get user statistics
  async getUserStatistics(userEmail) {
    try {
      const response = await apiClient.get(`/quiz/user-stats/${encodeURIComponent(userEmail)}`, { headers: { Authorization: `Bearer ${authService.getToken()}` } });
      return response.data;
    } catch (error) {
      const status = error.response?.status;
      if (status === 403) throw new Error('Forbidden');
      if (status === 401) throw new Error('Unauthorized');
      throw new Error(error.response?.data?.detail || 'Failed to fetch user statistics');
    }
  }

  async canStartQuiz(userEmail) {
    try {
      const response = await apiClient.get(`/quiz/can_start/${encodeURIComponent(userEmail)}`, { headers: { Authorization: `Bearer ${authService.getToken()}` } });
      return response.data;
    } catch (error) {
      const status = error.response?.status;
      if (status === 404) return { can_start: false };
      
      if (status === 403) throw new Error('Forbidden');
      if (status === 401) throw new Error('Unauthorized');
      throw new Error(error.response?.data?.detail || 'Failed to check start permission');
    }
  }

}

export default new QuizService();
